/* Awtomic Build-a-Box customization — per-shop behavior + layout injection.
   Loaded by snippets/awtomic-theme-custom.liquid.
   Edit ONLY the SHOP CONFIG block below. Everything underneath hooks the
   Awtomic widget's own class names and works unchanged on any theme — do not
   edit it unless the widget markup itself has changed. */

/* ==================================================================== */
/* ===== SHOP CONFIG — EDIT THIS ====================================== */
/* ==================================================================== */

/* CONFIGURE: one entry per Build-a-Box bundle id — the number at the end of
   /tools/bundle-subscriptions/bundle/<id>. The "default" entry is the fallback
   for any bundle id not listed, so always keep it and give it real copy.
   Fields:
     title  — heading shown over the banner image
     header — HTML block shown above the product grid ("items header")
     info   — HTML for the description (left) + details box (right)
     img    — banner image. EITHER a full URL (e.g. a Shopify Files image:
              "https://cdn.shopify.com/s/files/.../hero.jpg?width=1600") OR a
              filename uploaded to this theme's assets/ ("hero.jpg"). The URL
              form is usually easier — the merchant can swap the image in
              Content → Files without a theme deploy. */
/* CONFIGURE — filled for Gatlinburg Winery (CX-5107).
   One entry per Build-a-Box bundle id — the number at the end of
   /tools/bundle-subscriptions/bundle/<id>. Verified 2026-09-21: all three
   routes return 200 on www.gatlinburgwinery.com.
     15270302548332  GatlinBear Cub         (box minimum 4)
     15278754234732  GatlinBear Yearling    (box minimum 6, 15% off)
     15278755348844  Gatlinbear Black Bear  (box minimum 12, 20% off)
   Fields: title (drawn over the banner), header (above the product grid),
   info (description + details box), img (banner file in this theme's assets/,
   or a full https:// URL from Content > Files).
   The `default` entry is the fallback for any bundle id not listed. */

if (!document.getElementById("bab-styles")) {
  document.head.insertAdjacentHTML("beforeend", '<link rel="stylesheet" href="https://use.typekit.net/ece8imn.css">');
  const st = document.createElement("style");
  st.id = "bab-styles";
  st.textContent = `#bundleapp-subscriptions-portal .main-bab-header{display:flex;flex-direction:column;align-items:center;text-align:center;padding:36px 20px 24px;background:#f6efe7;border-radius:22px 22px 0 0;font-family:'forma-djr-micro',sans-serif}
#bundleapp-subscriptions-portal .main-bab-header .bab-logo{height:64px;width:auto;margin:0 0 16px;background:#fffdf9;border-radius:999px;padding:12px 24px;box-sizing:content-box;box-shadow:0 12px 28px -12px rgba(48,36,66,.4);transform:rotate(-2deg)}
#bundleapp-subscriptions-portal .main-bab-header h3{font-family:'trumpgothicpro',sans-serif !important;font-weight:700;font-size:48px;line-height:.95;text-transform:uppercase;letter-spacing:.01em;color:#ec4972;margin:0 0 8px}
#bundleapp-subscriptions-portal .main-bab-header p{margin:0;font-size:16px;color:#6b645e}
#bundleapp-subscriptions-portal .bab-copy{font-family:'forma-djr-micro',sans-serif}
#bundleapp-subscriptions-portal .bab-copy .bab-chip{display:inline-flex;padding:5px 12px;border-radius:999px;background:#fde4eb;color:#302442;font-family:'trumpgothicpro',sans-serif;font-weight:700;font-size:16px;letter-spacing:.08em;text-transform:uppercase;margin:0 0 14px}
#bundleapp-subscriptions-portal .bab-copy h3{font-family:'trumpgothicpro',sans-serif !important;font-weight:700;font-size:48px;line-height:.95;text-transform:uppercase;letter-spacing:.01em;color:#1f1c1a;margin:0 0 18px}
#bundleapp-subscriptions-portal .bab-copy p{font-size:16px;line-height:1.65;color:#3a3531;margin:0 0 14px;text-wrap:pretty}
#bundleapp-subscriptions-portal .bab-details{background:#302442;color:#fbf3ea;padding:28px;border-radius:24px;align-self:start;transform:rotate(1deg);box-shadow:0 18px 36px -20px rgba(48,36,66,.7);font-family:'forma-djr-micro',sans-serif}
#bundleapp-subscriptions-portal .bab-details h4{font-family:'trumpgothicpro',sans-serif;font-weight:700;font-size:30px;line-height:1;text-transform:uppercase;letter-spacing:.03em;color:#fbf3ea;margin:0 0 18px}
#bundleapp-subscriptions-portal .bab-details ol{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:12px;counter-reset:bab}
#bundleapp-subscriptions-portal .bab-details li{counter-increment:bab;color:inherit;display:flex;gap:12px;align-items:flex-start;font-size:15px;line-height:1.45}
#bundleapp-subscriptions-portal .bab-details li::before{content:counter(bab);flex:none;width:28px;height:28px;margin-top:-4px;border-radius:50%;background:#ec4972;color:#fff;display:flex;align-items:center;justify-content:center;font-family:'trumpgothicpro',sans-serif;font-weight:700;font-size:18px}
#bundleapp-subscriptions-portal .bundle-subscription-placeholder-img-text h1:empty{display:none}`;
  document.head.appendChild(st);
}

const babInfoMapping = {
  15270302548332: {
    /* The banner artwork already carries the club name, so no title is drawn
       over it. Put text back here if the artwork ever loses the lettering. */
    title: "",
    header:
      '<div class="main-bab-header"><img class="bab-logo" src="https://cdn.shopify.com/s/files/1/0897/7396/5676/files/GBW_Club_Logo_With_Paw.png?v=1788808392" alt="GatlinBear Wine Club"><h3>Build your GatlinBear Cub shipment</h3><p>Four bottles, chosen by you.</p></div>',
    info: `
      <div class="bab-copy">
        <span class="bab-chip">Your box, your way</span>
        <h3>Customize Your Shipment</h3>
        <p>We know everyone has different tastes, so you have the flexibility to make each shipment your own. Two wines from each quarterly selection are required to remain in your shipment, while you can swap the remaining two bottles for other available wines.</p>
        <p>Want a little extra? Add additional bottles to your club shipment without paying additional shipping charges. It&rsquo;s an easy way to stock up on your favorites or try something new.</p>
      </div>
      <aside class="bab-details">
        <h4>Membership Details</h4>
        <ol>
          <li>4 bottles in every shipment.</li>
          <li>Two wines from each quarterly release stay in the box.</li>
          <li>Swap the other two bottles for any available wine.</li>
          <li>Shipments arrive every three months.</li>
        </ol>
      </aside>
    `,
    img: "https://cdn.shopify.com/s/files/1/0897/7396/5676/files/CubBanner.png?v=1790104683"
  },
  15278754234732: {
    title: "",
    header:
      '<div class="main-bab-header"><img class="bab-logo" src="https://cdn.shopify.com/s/files/1/0897/7396/5676/files/GBW_Club_Logo_With_Paw.png?v=1788808392" alt="GatlinBear Wine Club"><h3>Build your GatlinBear Yearling shipment</h3><p>Six bottles, chosen by you.</p></div>',
    info: `
      <div class="bab-copy">
        <span class="bab-chip">Your box, your way</span>
        <h3>Customize Your Shipment</h3>
        <p>We know everyone has different tastes, so you have the flexibility to make each shipment your own. Two wines from each quarterly selection are required to remain in your shipment, while you can swap the remaining four bottles for other available wines.</p>
        <p>Want a little extra? Add additional bottles to your club shipment without paying additional shipping charges. It&rsquo;s an easy way to stock up on your favorites or try something new.</p>
      </div>
      <aside class="bab-details">
        <h4>Membership Details</h4>
        <ol>
          <li>6 bottles in every shipment.</li>
          <li>Two wines from each quarterly release stay in the box.</li>
          <li>Swap the other four bottles for any available wine.</li>
          <li>15% off every shipment.</li>
          <li>Shipments arrive every three months.</li>
        </ol>
      </aside>
    `,
    img: "https://cdn.shopify.com/s/files/1/0897/7396/5676/files/Yearling_Banner.png?v=1790104683"
  },
  15278755348844: {
    title: "",
    header:
      '<div class="main-bab-header"><img class="bab-logo" src="https://cdn.shopify.com/s/files/1/0897/7396/5676/files/GBW_Club_Logo_With_Paw.png?v=1788808392" alt="GatlinBear Wine Club"><h3>Build your GatlinBear Black Bear shipment</h3><p>Twelve bottles, chosen by you.</p></div>',
    info: `
      <div class="bab-copy">
        <span class="bab-chip">Your box, your way</span>
        <h3>Customize Your Shipment</h3>
        <p>We know everyone has different tastes, so you have the flexibility to make each shipment your own. Two wines from each quarterly selection are required to remain in your shipment, while you can swap the remaining ten bottles for other available wines.</p>
        <p>Want a little extra? Add additional bottles to your club shipment without paying additional shipping charges. It&rsquo;s an easy way to stock up on your favorites or try something new.</p>
      </div>
      <aside class="bab-details">
        <h4>Membership Details</h4>
        <ol>
          <li>12 bottles in every shipment.</li>
          <li>Two wines from each quarterly release stay in the box.</li>
          <li>Swap the other ten bottles for any available wine.</li>
          <li>20% off every shipment.</li>
          <li>Shipments arrive every three months.</li>
        </ol>
      </aside>
    `,
    img: "https://cdn.shopify.com/s/files/1/0897/7396/5676/files/Black_Bear_Banner.png?v=1790104683"
  },
  default: {
    title: "",
    header:
      '<div class="main-bab-header"><img class="bab-logo" src="https://cdn.shopify.com/s/files/1/0897/7396/5676/files/GBW_Club_Logo_With_Paw.png?v=1788808392" alt="GatlinBear Wine Club"><h3>Build your club shipment</h3><p>Four bottles, chosen by you.</p></div>',
    info: `
      <div class="bab-copy">
        <span class="bab-chip">Your box, your way</span>
        <h3>Customize Your Shipment</h3>
        <p>We know everyone has different tastes, so you have the flexibility to make each shipment your own. Two wines from each quarterly selection are required to remain in your shipment, while you can swap the remaining two bottles for other available wines.</p>
        <p>Want a little extra? Add additional bottles to your club shipment without paying additional shipping charges. It&rsquo;s an easy way to stock up on your favorites or try something new.</p>
      </div>
      <aside class="bab-details">
        <h4>Membership Details</h4>
        <ol>
          <li>4 bottles in every shipment.</li>
          <li>Two wines from each quarterly release stay in the box.</li>
          <li>Swap the other two bottles for any available wine.</li>
          <li>Shipments arrive every three months.</li>
        </ol>
      </aside>
    `,
    img: "https://cdn.shopify.com/s/files/1/0897/7396/5676/files/CubBanner.png?v=1790104683"
  }
};
const babMinimums = {
  // "1234567890123": {
  //   2345678901234: 60,
  //   2345678901235: 120
  // }
};

/* CONFIGURE: optional post-BaB upsell popup, shown after "add to cart".
   Leave variantId unset (or the whole object empty) and no popup appears —
   the customer goes straight to the cart. */
window.babUpsellConfig = {
  // variantId: 2345678901234,               // Shopify variant id added on Accept
  // heading: "Exclusive New Member Offer",
  // description: "Add this to your first shipment.",
  // productTitle: "Library Cabernet",
  // imageUrl: "https://cdn.shopify.com/...", // product image URL
  // priceLabel: "$45",
  // compareAtLabel: "$60",
};

/* CONFIGURE: optional external cancel-flow URL (no query string). When set,
   the customer-portal Cancel button opens
   <url>?winery=<shop>&token=<portal token>&sub=<subscription id> in a new tab
   instead of the widget's native cancel flow. Leave "" for native cancel. */
const babCancelRedirectUrl = "";

/* CONFIGURE: optional overrides for the Awtomic Cart Rollup library
   (awtomic-cart-extras — loaded from snippets/awtomic-theme-custom.liquid; see
   the OPTIONAL: cart rollup block there). The library auto-detects the common
   Shopify themes, so MOST SHOPS NEED NOTHING HERE — leave it commented out.
   Only supply a `theme` override for a theme it can't detect, and only turn on
   debugMode while debugging (it logs to every visitor's console). */
// window.awtomicCartExtrasConfig = {
//   debugMode: false,
//   theme: {
//     name: "Custom",
//     detect: () => true,
//     selectors: { /* see the library's theme definitions for the shape */ },
//   },
// };

/* ==================================================================== */
/* ===== END SHOP CONFIG — do not edit below this line ================ */
/* ==================================================================== */

// Clean up hiddenStepper for non-BAB purchase flows
(function () {
  const isBabPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

  if (!isBabPurchaseFlow) {
    // Immediate cleanup
    document.body.classList.remove("hiddenStepper");
    sessionStorage.removeItem("awtHiddenStepper");

    // Also cleanup on DOMContentLoaded to ensure it's removed
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        document.body.classList.remove("hiddenStepper");
        sessionStorage.removeItem("awtHiddenStepper");
      });
    }
  }
})();

// ===== Build-A-Box upsell popup =====
const babUpsell = (() => {
  let modalEl = null;
  let lastFocusedEl = null;

  const buildModal = () => {
    const cfg = window.babUpsellConfig || {};
    const wrap = document.createElement("div");
    wrap.className = "bab-upsell-modal";
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "bab-upsell-title");
    wrap.setAttribute("aria-hidden", "true");
    wrap.innerHTML = `
      <div class="bab-upsell-modal__dialog" tabindex="-1">
        <button type="button" class="bab-upsell-modal__close" data-bab-upsell-close aria-label="Close">&times;</button>
        <h2 class="bab-upsell-modal__title" id="bab-upsell-title">${escapeHtml(cfg.heading || "Exclusive New Member Offer")}</h2>
        <p class="bab-upsell-modal__subtitle">${escapeHtml(cfg.description || "")}</p>
        <div class="bab-upsell-modal__product">
          <div class="bab-upsell-modal__image-wrap">
            ${cfg.imageUrl ? `<img src="${escapeAttr(cfg.imageUrl)}" alt="${escapeAttr(cfg.productTitle || "")}" />` : ""}
          </div>
          <h3 class="bab-upsell-modal__product-title">${escapeHtml(cfg.productTitle || "")}</h3>
          <div class="bab-upsell-modal__pricing">
            ${cfg.compareAtLabel ? `<div class="bab-upsell-modal__compare-at">Price: <span>${escapeHtml(cfg.compareAtLabel)}</span></div>` : ""}
            <div class="bab-upsell-modal__offer">Offer Price: <span>${escapeHtml(cfg.priceLabel || "")}</span></div>
          </div>
        </div>
        <div class="bab-upsell-modal__actions">
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__accept" data-bab-upsell-accept>Accept</button>
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__decline" data-bab-upsell-decline>Decline</button>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);
    return wrap;
  };

  const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const escapeAttr = (str) => escapeHtml(str);

  const finish = (discount) => {
    if (discount) {
      window.location.assign(`/discount/${encodeURIComponent(discount)}?redirect=/cart`);
    } else {
      window.location.assign("/cart");
    }
  };

  const close = () => {
    if (!modalEl) return;
    modalEl.classList.remove("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bab-upsell-locked");
    document.removeEventListener("keydown", onKeydown);
    if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
      lastFocusedEl.focus();
    }
  };

  const onKeydown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      const decline = modalEl?.querySelector("[data-bab-upsell-decline]");
      decline?.click();
    }
  };

  const open = (discount) => {
    if (!modalEl) modalEl = buildModal();
    const cfg = window.babUpsellConfig || {};
    if (!cfg.variantId) {
      console.warn("[bab-upsell] No variantId configured; skipping popup");
      finish(discount);
      return;
    }

    lastFocusedEl = document.activeElement;
    modalEl.classList.add("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "false");
    document.body.classList.add("bab-upsell-locked");

    const dialog = modalEl.querySelector(".bab-upsell-modal__dialog");
    dialog?.focus();

    const acceptBtn = modalEl.querySelector("[data-bab-upsell-accept]");
    const declineBtn = modalEl.querySelector("[data-bab-upsell-decline]");
    const closeBtn = modalEl.querySelector("[data-bab-upsell-close]");

    const handleDecline = (e) => {
      e?.preventDefault();
      close();
      finish(discount);
    };

    const handleAccept = async (e) => {
      e?.preventDefault();
      acceptBtn.disabled = true;
      declineBtn.disabled = true;
      closeBtn.disabled = true;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
        });
      } catch (err) {
        console.error("[bab-upsell] add-to-cart failed", err);
      }
      finish(discount);
    };

    const handleBackdrop = (e) => {
      if (e.target === modalEl) handleDecline(e);
    };

    acceptBtn.onclick = handleAccept;
    declineBtn.onclick = handleDecline;
    closeBtn.onclick = handleDecline;
    modalEl.onclick = handleBackdrop;
    document.addEventListener("keydown", onKeydown);
  };

  return { open };
})();

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600, /* CONFIGURE (optional): BaB product image size in px */
    addToCartRedirect: ({ discountCode, discount } = {}) => {
      babUpsell.open(discountCode || discount);
    }
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // Intercept cancel button and redirect to external cancellation flow
  // (only when babCancelRedirectUrl is configured above)
  if (babCancelRedirectUrl) {
    waitForElement(".bundle-button--cancel", (originalBtn) => {
      originalBtn.style.display = "none";

      const clonedBtn = originalBtn.cloneNode(true);
      clonedBtn.style.display = "";
      clonedBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const rawSubscriptionId = window.Awtomic?.subscriptionDetails?.SubscriptionId || "";
        const subscriptionId = rawSubscriptionId.split("/").pop();
        const winery = window.Shopify?.shop || "";
        const token = (() => {
          try {
            const raw = localStorage.getItem("awtomicApiAuth");
            return raw ? JSON.parse(raw).authToken || "" : "";
          } catch { return ""; }
        })();

        window.open(
          `${babCancelRedirectUrl}?winery=${encodeURIComponent(winery)}&token=${encodeURIComponent(token)}&sub=${subscriptionId}`,
          "_blank"
        );
      });

      originalBtn.parentNode.insertBefore(clonedBtn, originalBtn.nextSibling);
    });
  }

  // CP PRICE CHECK
  waitForElement(".bundle-table__body-row--bab-parent", (element) => {
    const checkBabEdit = (bundleId, variantId) => {
      const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

      const setAddToCartMinimumPrice = () => {
        const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

        if (!bundleContainer) return;

        const infoDiv = document.createElement("div");
        infoDiv.className = "minimum-price-info";
        infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

        const footerDiv = bundleContainer.querySelector("footer > div");
        if (footerDiv) {
          const lastDiv = footerDiv.querySelector("div:last-child");
          if (lastDiv) {
            footerDiv.insertBefore(infoDiv, lastDiv);
          }
        }

        document.body.addEventListener("click", (e) => {
          const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
          const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

          const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
          if (innerPrice < minimumPrice) {
            addToCartButton.classList.add("priceNotMet");
            document.body.classList.add("priceNotMet");
          } else {
            addToCartButton.classList.remove("priceNotMet");
            document.body.classList.remove("priceNotMet");
          }
        });
      };

      const checkIfPriceLabel = () =>
        document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

      let priceLabelSet = false;

      if (checkIfPriceLabel()) {
        setAddToCartMinimumPrice();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (!priceLabelSet && mutation.addedNodes.length) {
              if (checkIfPriceLabel()) {
                setAddToCartMinimumPrice();
                priceLabelSet = true;
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }
    };

    Object.keys(babMinimums).forEach((bundleId) => {
      Object.keys(babMinimums[bundleId]).forEach((variantId) => {
        const selector = `tr[class*="${variantId}"]`;
        const element = document.querySelector(selector);
        console.log(selector, element);
        if (element) element.addEventListener("click", () => checkBabEdit(bundleId, variantId));
      });
    });
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  // Check if coming from product PDP
  const referrer = document.referrer;
  const fromPDP = referrer && referrer.includes("/products/");

  if (fromPDP) {
    document.body.classList.add("hiddenStepper");
    sessionStorage.setItem("awtHiddenStepper", "true");
  } else if (sessionStorage.getItem("awtHiddenStepper") === "true") {
    document.body.classList.add("hiddenStepper");
  }

  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_1234567890123.pv_2345678901235)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;
          console.log(`Setting up price checking for variant ${variantId} with minimum price $${minimumPrice}`);

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            document.body.addEventListener("click", (e) => {
              const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
              const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (innerPrice < minimumPrice) {
                addToCartButton.classList.add("priceNotMet");
                document.body.classList.add("priceNotMet");
              } else {
                addToCartButton.classList.remove("priceNotMet");
                document.body.classList.remove("priceNotMet");
              }
            });
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                console.log(`Variant changed from ${currentVariantId} to ${newVariantId}`);
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }

    //Add subscription info blocks for all bundle products
    waitForElement(".bundleapp-modal__container--complete-screen .bundle-container", (container) => {
      const imgId = "bundle-subscription-placeholder-img";

      if (!document.getElementById(imgId)) {
        // Insert image container
        var imgContainer = document.createElement("div");
        imgContainer.className = "bundle-subscription-placeholder-img-container";

        var img = document.createElement("img");
        const imgFilename = babInfoMapping[bundleId]?.img || babInfoMapping.default.img;
        // The configured banner may be a full URL (a Shopify Files image, a
        // CDN) or a filename uploaded to this theme's assets/ — only the
        // filename form goes through the awtAssetPath shim.
        img.src = /^https?:\/\//.test(imgFilename)
          ? imgFilename
          : window.awtAssetPath.replace("xxxxxxxx.jpg", imgFilename);
        img.id = imgId;
        imgContainer.appendChild(img);

        var imgText = document.createElement("div");
        imgText.className = "bundle-subscription-placeholder-img-text";
        imgText.innerHTML = `<h1>${babInfoMapping[bundleId]?.title || babInfoMapping.default.title}</h1>`;
        imgContainer.appendChild(imgText);

        container.insertBefore(imgContainer, container.firstChild);

        // Insert subscription info block
        var info = document.createElement("div");
        info.className = "bundle-subscription-info";
        info.innerHTML = babInfoMapping[bundleId]?.info || babInfoMapping.default.info;
        container.insertBefore(info, imgContainer.nextSibling);

        // Insert items header before create-content
        const createContent = document.querySelector(".bundle-create-content");
        if (createContent) {
          var itemsheader = document.createElement("div");
          itemsheader.className = "bundle-subscription-itemsheader";
          itemsheader.innerHTML = babInfoMapping[bundleId]?.header || babInfoMapping.default.header;
          container.insertBefore(itemsheader, createContent);
        }
      }
    });
  }
}

/* Cart rollup is NOT part of this kit.
   This file used to end with a single-theme "remove bundle" click handler that
   zeroed every _bundleUid line via /cart/update.js. It has been removed: the
   shop-independent Awtomic Cart Rollup library (awtomic-cart-extras) supersedes
   it, handling detection, rendering and removal across every supported theme.
   Enable that library from snippets/awtomic-theme-custom.liquid — and do not
   re-add a second rollup handler here, or the two double-bind the same click. */
